module.exports = __webpack_public_path__ + "img/synopsis4.bde0ea3.svg";